import { render, staticRenderFns } from "./CopyPolicy.vue?vue&type=template&id=2c9ae8c4&"
import script from "./CopyPolicy.vue?vue&type=script&lang=js&"
export * from "./CopyPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports